import { ComponentProps } from "react";
import { styled, Text, Button as TGButton, ThemeableStack } from "tamagui";

import { ArrowLeft, ArrowRight } from "../../icons";
import { Button } from "./button";

const PaginationBody = styled(ThemeableStack, {
  tag: "nav",
  role: "navigation",
  flexDirection: "row",
  justifyContent: "center",
  width: "100%",
  marginHorizontal: "auto",
});

const PaginationContent = styled(ThemeableStack, {
  tag: "ul",
  flexDirection: "row",
  alignItems: "center",
  gap: "$2",
});

const PaginationItem = styled(ThemeableStack, {
  tag: "li",
});

const PaginationLink = styled(TGButton, {
  width: "$3",
  height: "$3",
  borderRadius: "$1",
  padding: 0,
  fontFamily: "$body",
  fontSize: "$3",
  cursor: "pointer",
  variants: {
    active: {
      true: {
        fontWeight: "$6",
        backgroundColor: "$lightgreen-500",
        color: "white",
      },
      false: {
        fontWeight: "$4",
        color: "$gray-600",
        backgroundColor: "transparent",
        hoverStyle: {
          color: "$gray-primary-900",
        },
      },
    },
  } as const,
  defaultVariants: {
    active: false,
  },
});

type PaginationLinkProps = ComponentProps<typeof Button>;

const PaginationPrevious: React.FC<PaginationLinkProps> = (props) => {
  return (
    <Button variant="gray" size="md" rounded="lg" mode="icon" {...props}>
      <ArrowLeft />
    </Button>
  );
};

const PaginationNext: React.FC<PaginationLinkProps> = (props) => {
  return (
    <Button variant="gray" size="md" rounded="lg" mode="icon" {...props}>
      <ArrowRight />
    </Button>
  );
};

const PaginationEllipsisBase = styled(Text, {
  alignItems: "center",
  justifyContent: "center",
  fontFamily: "$body",
  fontSize: "$3",
  lineHeight: "$3",
  color: "$gray-600",
});

type PaginationEllipsisProps = ComponentProps<typeof PaginationEllipsisBase>;

const PaginationEllipsis: React.FC<PaginationEllipsisProps> = (props) => {
  return <PaginationEllipsisBase {...props}>...</PaginationEllipsisBase>;
};

export const Pagination = {
  Body: PaginationBody,
  Content: PaginationContent,
  Item: PaginationItem,
  Link: PaginationLink,
  Previous: PaginationPrevious,
  Next: PaginationNext,
  Ellipsis: PaginationEllipsis,
};
